import * as React from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Badge from '@mui/material/Badge';

const items = [
  { text: 'Posts', link:'posts' },
  { text: 'Speakers', link:'speakers' },
  { text: 'People', link:'people' },
  { text: 'Sponsors', link:'sponsors' },
  { text: 'Maps', link:'admin' },
  { text: 'Scheduler', link:'scheduler' },
  { text: 'Resources', link:'resources' },
];

const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

function ResponsiveJoinedAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const {eventCode} = useParams();

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const openCart = (event) => {
    navigate(`/explore/${eventCode}/cart`);
  };


  return (
    <AppBar position="sticky" elevation={0} color="textPrimary" sx={{bgcolor: 'background.paper', }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Diversity2Icon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            NKUVU
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup= 'true'
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
             color="textPrimary"
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
              >             
              {items.map((item, index) => (
                <MenuItem 
                  key={index} 
                  onClick={handleCloseNavMenu} 
                  button 
                  component={Link} 
                  to={`/join/${eventCode}/${item.link}`} 
                  >
                  <Typography 
                    sx={{ textAlign: 'center' }}  
                    color="textPrimary">{item.text}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Diversity2Icon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            NKUVU
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }} >            
            {items.map((item, index) => (
                <MenuItem 
                  key={index} 
                  onClick={handleCloseNavMenu}  
                  button component={Link} 
                  to={`/join/${eventCode}/${item.link}`} 
                  >
                  <Typography 
                    sx={{ textAlign: 'center' }}  
                    color="textPrimary">{item.text}
                  </Typography>
                </MenuItem>
              ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={openCart}
            >
              <Badge variant="dot">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Agnelio X" src="/static/images/avatar/2.jpg" />
              </IconButton>        
            </Tooltip>
            
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
       {/* {document.title = "nKuvu - " + eventData.eventName} */}
    </AppBar>
  );
}
export default ResponsiveJoinedAppBar;
